const swiperChampionshipRaces = {
    swiperInstance: null,
    init: () => {
        import("swiper/bundle").then(({ Swiper }) => {
            let domEls = document.querySelectorAll(
                ".js-swiper-championship-races"
            );
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach((el) => {
                    swiperChampionshipRaces.swiperInstance = new Swiper(
                        el,
                        params
                    );
                });
            }
        });
    },
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        spaceBetween: 32,
        slidesPerView: "auto",
        resizeObserver: true,
        slideToClickedSlide: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true,
        },
        grabCursor: true,
        on: {
            init: function () {

                // slide to "selected" tab -> useful inside championship pages where there could be more tabs than the viewport can contain

                const slides = this.slides;
                function getSlideIndexByClass(className) {
                    let index = 0;
                    const swiperWrapperChildren = slides;
                    for (let i = 0; i < swiperWrapperChildren.length; i++) {
                        const item = swiperWrapperChildren[i];
                        if (item.classList.contains(className)) {
                            index = i;
                            break;
                        }
                    }
                    return index;
                }
                this.slideTo(getSlideIndexByClass('selected'), 0, false);
            }
        }
    };
};

export default swiperChampionshipRaces;
